export default function PriorityBadge({ priority }) {
  const map = {
    high: { label: "ALTA", cls: "bg-red-500/10 text-red-400 border-red-500/30" },
    medium: { label: "MEDIA", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
    low: { label: "BAJA", cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30" },
  };
  const cfg = map[priority] || map.low;
  return (
    <span
      className={`text-[10px] px-1.5 py-0.5 rounded-full border font-mono tracking-[0.15em] ${cfg.cls}`}
      data-testid={`priority-badge-${priority}`}
    >
      {cfg.label}
    </span>
  );
}
